/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Gender {
    MALE = 'male',
    FEMALE = 'female',
    UNKNOWN = 'unknown',
}
